import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Grid, Box, Paper, Typography, Button } from '@material-ui/core'
import LinkIcon from '@material-ui/icons/Link'
import { useDispatch } from 'react-redux'

import { getCardComponent } from '../card_components'
import useOneCardDb from '../hooks/useOneCardDb'
import { updateCard } from '../redux/cardDbSlice'
import BookTreeForLink from './BookTreeForLink'

const CardBasePaper = styled(Paper)`
  width: 200px;
`
const LabelTypography = styled(Typography)`
  color: #9e9e9e;
`
const LargeLinkIcon = styled(LinkIcon)`
  position: relative;
  top: 68px;
  font-size: 40px;
`
const BookTreeBox = styled(Box)`
  height: 60vh;
  margin-bottom: 8px;
  border: solid 1px black;
  overflow: auto;
`

type AddCardLinkDialogProps = {
  open: boolean
  onClose: () => void
  id?: string
}
const AddCardLinkDialog: React.FC<AddCardLinkDialogProps> = ({open, onClose, id}) => {
  const dispatch = useDispatch()
  const [checked, setChecked] = useState<string[]>([]) //リンクを貼るシートIDが入ってくる
  const card = useOneCardDb(id)

  useEffect(() => { //リンクデータ初期化
    if (card) {
      let linkedIds:string[] = [];    
      card.links?.map((link) => linkedIds.push(link));
      setChecked(linkedIds);
    }
  }, [card])

  const saveCardLink = () => { //リンクデータを保存する
    if(id) {
console.log('次のシートリンクを保存します' + checked)
        dispatch(updateCard({id: id, sheetKind: card?.sheetKind, links: checked }));
    }
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>このカードから他のシートへのリンクを設定します</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={3}>
            <LabelTypography variant="caption">このカードから</LabelTypography>
            {(card !== undefined && id) &&
              <CardBasePaper variant="outlined">
                {getCardComponent(card.kind, id)}
              </CardBasePaper>
            }
          </Grid>
          <Grid item xs={1}><LargeLinkIcon /></Grid>
          <Grid item xs={8}>
            <LabelTypography variant="caption">チェックしたシートまでリンクを張る</LabelTypography>
            <BookTreeBox>
              <BookTreeForLink checked={checked} setChecked={setChecked}/>
            </BookTreeBox>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='text' color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button variant='text' color='primary' onClick={saveCardLink}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddCardLinkDialog
